import * as THREE from "three";
import { graph, vectors } from "./constants";

/**
 * Create a curve between vector points
 * @param {THREE.Vector3[]} vectors - Vector array to draw curve
 * @param {number} [numPoints=200] - For each tuple point number
 * @returns {THREE.CatmullRomCurve3}
 */
export const createCurve = (vectors, numPoints = 200) => {
  return new THREE.CatmullRomCurve3(vectors);
};

/**
 * Create a target for the camera at the end of the path
 * @param {THREE.Vector3} vector - The last vector at the end of the path
 * @returns {THREE.Mesh} Object that the camera will look at
 */
export const createLookAtObject = (vector, customOffset = null) => {
  const { x, y, z } = vector;

  const geometry = new THREE.BoxGeometry(1, 1, 1);
  const material = new THREE.MeshBasicMaterial({ color: 0x0005e99 });
  const mesh = new THREE.Mesh(geometry, material);

  // If there is a special offset apply it
  if (customOffset) {
    mesh.position.set(x + customOffset.x, y + customOffset.y, z + customOffset.z);
  } else {
    mesh.position.set(x, y, z);
  }

  return mesh;
};

/**
 * Create a path for the camera along with
 * @param {string} source
 * @param {string} destination
 */
export const getShortestWayPointsArray = (source, destination) => {
  // Use Graph method to get shortest way on the graph
  const shortestWay = graph.path(source, destination);

  // Error Handling
  if (!shortestWay || shortestWay.length === 0) {
    console.error(`Path not found from ${source} to ${destination}`);
    console.log("Available nodes:", Object.keys(graph.graph));
    return null;
  }

  console.log("Shortest path:", shortestWay);

  // Transform nodename array to Vector3 array
  const vectorArray = shortestWay.map((nodeName) => {
    //Find the nodeName in vectors
    const nodeEntry = vectors.find((v) => {
      const [name] = Object.keys(v);
      return name === nodeName;
    });

    if (!nodeEntry) {
      console.error(`Node ${nodeName} not found in vectors`);
      return null;
    }

    const coordinate = nodeEntry[nodeName];


    const { x, y, z } = coordinate;
    return new THREE.Vector3(x, y, z);
  }).filter(v => v !== null);

  return vectorArray;
};